// extracted by mini-css-extract-plugin
export var productImage = "_nc-0";